const mutations = {
  setGuideBook: (state, data) => {
    state.guide_book = data;
  },
  setGuideBookDetail: (state, data) => {
    state.guide_book_detail = data;
  },
};

export default mutations;
